import { RcClasses } from '../../../../foundation';
export var RcTextareaInputClasses = RcClasses(['inputMultiline', 'root'], 'RcTextareaInput');
